import React, { useState } from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import InputGroup from "react-bootstrap/InputGroup";
import * as formik from "formik";
import * as yup from "yup";
import { forgotPassword } from "../services/authService";
import AlertCustom from "../components/AlertCustom/AlertCustom";

const ForgotPassword = () => {
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  const { Formik } = formik;

  const schema = yup.object().shape({
    Email: yup.string().email().required(),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true)
    setNotification();

    const data = {
      language: "en",
      email: values.Email,
      is_mobile: false,
    };
    console.log("data", data);
    try {
      const res = await forgotPassword(data);
      console.log("Forgot Password successful:", res);
      setNotification(
        <AlertCustom
          message={res?.message ?? "something went wrong"}
          variant="success"
        />
      );
      resetForm();
      // navigate('/auth/login', { replace: true });
    } catch (error) {
      setNotification(
        <AlertCustom
          message={error?.response?.data?.message ?? "something went wrong"}
          variant="danger"
        />
      );
      console.error("Authentication failed:", error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="text-center">
        <h1 className="fs-1 fw-bold text-gray-700 mb-2">Forgot Password?</h1>
        <h2 className="fs-5 fw-normal text-gray-500">
          No worries, we'll send you the reset instructions
        </h2>
      </div>
      <Formik
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleSubmit}
        initialValues={{
          Email: "",
        }}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form className="mt-5" onSubmit={handleSubmit}>
            {notification}
            <Form.Group className="mb-4" controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              <div className="input-warpper email-icon">
                <Form.Control
                  type="text"
                  placeholder="Enter your email"
                  aria-describedby="inputGroupPrepend"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  isInvalid={!!errors.Email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Email}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Button type="submit" className="btn btn-primary w-100 mt-5" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : "Send Instructions"}
            </Button>
          </Form>
        )}
      </Formik>
      <p className="text-center mt-2">
        <Link
          to="/auth/login"
          className="fs-16 text-gray-700 fw-semibold text-decoration-none"
        >
          Cancel
        </Link>
      </p>
    </>
  );
};

export default ForgotPassword;
